import styled from '@emotion/styled'

const ArticleRelatedArticleInfoAuthorInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export default ArticleRelatedArticleInfoAuthorInfo